import axios from 'axios';

import { notifyUnauthorized } from '@/features/auth/authState';
import { csrfHeaderResolver } from '@/features/auth/csrf';
import { OpenAPI as AppsOpenAPI } from './generated';
import { OpenAPI as DataOpenAPI } from './generated/dataApi';

let generatedUnauthorizedInterceptorInstalled = false;

function installGeneratedUnauthorizedInterceptor(): void {
  if (generatedUnauthorizedInterceptorInstalled) {
    return;
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        notifyUnauthorized();
      }

      return Promise.reject(error);
    },
  );
  generatedUnauthorizedInterceptorInstalled = true;
}

/**
 * 初始化生成的 API 客户端配置
 * 在应用启动时（main.tsx）调用
 */
export function setupOpenApi(): void {
  // VITE_API_URL 包含 /api/v1 前缀，但生成的代码路径已包含 /api/v1
  // 因此 BASE 需要去掉 /api/v1 后缀
  const apiUrl = import.meta.env.VITE_API_URL || '';
  const base = apiUrl.replace(/\/api\/v1\/?$/, '');
  AppsOpenAPI.BASE = base;
  AppsOpenAPI.WITH_CREDENTIALS = true;
  AppsOpenAPI.HEADERS = csrfHeaderResolver;
  AppsOpenAPI.ENCODE_PATH = encodeURIComponent;
  DataOpenAPI.BASE = base;
  DataOpenAPI.WITH_CREDENTIALS = true;
  DataOpenAPI.HEADERS = csrfHeaderResolver;
  installGeneratedUnauthorizedInterceptor();
}
